
import React from "react";
import { Button } from "@/components/ui/button";
import { LineChart, AreaChart } from "lucide-react";
import { type ChartType } from "./chart-data";

interface ChartTypeSelectorProps {
  chartType: ChartType;
  onChartTypeChange: (type: ChartType) => void;
}

export function ChartTypeSelector({ 
  chartType, 
  onChartTypeChange 
}: ChartTypeSelectorProps) {
  return (
    <div className="flex justify-center gap-2 mb-4">
      <Button 
        variant={chartType === "line" ? "default" : "outline"} 
        size="sm"
        onClick={() => onChartTypeChange("line")}
        className="flex items-center gap-1"
      >
        <LineChart className="h-3 w-3" />
        <span>Points per Game</span>
      </Button>
      <Button 
        variant={chartType === "cumulative" ? "default" : "outline"} 
        size="sm"
        onClick={() => onChartTypeChange("cumulative")}
        className="flex items-center gap-1"
      >
        <AreaChart className="h-3 w-3" />
        <span>Total Points</span>
      </Button>
    </div>
  );
}
